module.exports = __webpack_public_path__ + "img/company_cerfive.05888089.png";